import { createFileRoute, Outlet } from '@tanstack/react-router';

import { safeCheckIsAuth } from '#modules/user/features/auth/utils/checkIsAuth';
import { DashboardLayout } from '#modules/user/features/dashboard/components/DashboardLayout';
import { ErrorNotFound } from '#features/error/components/ErrorNotFound';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard')({
  loader: async () => {
    const { isAuth, status } = await safeCheckIsAuth();

    return { isAuth, authStatus: status };
  },
  ssr: false,
  component: LayoutComponent,
  notFoundComponent: ErrorNotFound,
});

/**
 * ReCaptchaProvider здесь намеренно нет: капча нужна ровно трём страницам дашборда
 * (`settings/account`, `feedback`, `players/$playerId` — там репорт из меню профиля), и каждая
 * монтирует провайдер сама. На уровне лейаута скрипт Google висел на всех страницах разом,
 * включая чаты, а его токен живёт две минуты — протухнув, он кидал `reCAPTCHA Timeout (b)`
 * необработанным реджектом в людей, которые просто переписывались.
 */
function LayoutComponent() {
  const { isAuth } = Route.useLoaderData();

  return (
    <DashboardLayout isAuth={isAuth}>
      <Outlet />
    </DashboardLayout>
  );
}
